// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SaveTemplatePopover-module__saveTemplatePopoverPaper--GF8Wc{max-width:515px}.SaveTemplatePopover-module__saveTemplatePopoverContainer--Br559 .SaveTemplatePopover-module__actions--u0N2I{display:flex;flex-direction:column;gap:12px;margin-top:12px}.SaveTemplatePopover-module__saveTemplatePopoverContainer--Br559 .SaveTemplatePopover-module__body--z5KTa{text-align:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"saveTemplatePopoverPaper": `SaveTemplatePopover-module__saveTemplatePopoverPaper--GF8Wc`,
	"saveTemplatePopoverContainer": `SaveTemplatePopover-module__saveTemplatePopoverContainer--Br559`,
	"actions": `SaveTemplatePopover-module__actions--u0N2I`,
	"body": `SaveTemplatePopover-module__body--z5KTa`
};
module.exports = ___CSS_LOADER_EXPORT___;
